const state = {
    currentAttributeDrawed:{},
    currentEditedBox:{},
    isAdd:1,
    isEleAdd:1,//围栏
    boxDetailShow:false,
    boxId:null,
    pepopleCount:0,//在场人员数量
    area_Count:0,//区域数量
    dArea_Count:0,//低风险区域数量
    ybArea_Count:0,//一般风险区域数量
    jdArea_Count:0,//较大风险区域数量
    zdArea_Count:0,//重大风险区域数量
    isCollapse:false,//菜单收缩
}
const getters = {
    boxDetailShow(){return state.boxDetailShow},
    boxId(){return state.boxId},
    getter_currentAttributeDrawed() {
        return state.currentAttributeDrawed
    },
    getter_currentEditedBox() {
        return state.currentEditedBox
    },
    getter_isAdd() {
        return state.isAdd
    },
    pepopleCount:(state)=>{return state.pepopleCount},//在场人员数量
    area_Count:(state)=>{return state.area_Count},//区域数量
    dArea_Count:(state)=>{return state.dArea_Count},//低风险区域数量
    ybArea_Count:(state)=>{return state.ybArea_Count},//一般风险区域数量
    jdArea_Count:(state)=>{return state.jdArea_Count},//较大风险区域数量
    zdArea_Count:(state)=>{return state.zdArea_Count},//重大风险区域数量
    isCollapse:(state)=>{return state.isCollapse},//菜单收缩 
}
const mutations = {
    setpepopleCount:(state,count)=>{state.pepopleCount=count},//在场人员数量
    setarea_Count:(state,count)=>{state.area_Count=count},//区域数量
    setdArea_Count:(state,count)=>{state.dArea_Count=count},//低风险区域数量
    setybArea_Count:(state,count)=>{state.ybArea_Count=count},//一般风险区域数量
    setjdArea_Count:(state,count)=>{state.jdArea_Count=count},//较大风险区域数量
    setzdArea_Count:(state,count)=>{state.zdArea_Count=count},//重大风险区域数量
    setIsCollapse:(state,count)=>{state.isCollapse=count},//菜单收缩 
    toggleBoxDetailShow(state,isShow=false){
        state.boxDetailShow=isShow
    },
    //设置box的BoxId
    setBoxId(state,id){
        state.boxId=id
    },
    change_currentAttributeDrawed(state, param) {
        state.currentAttributeDrawed = param.info;
    },
    change_currentEditedBox(state, param) {
        state.currentEditedBox = param.info;
    },
    change_isAdd(state, param) {
        state.isAdd = param.info;
    },
    //围栏
    change_isEleAdd(state, param) {
        state.isEleAdd = param.info;
    }
}
const actions = {
    toggleBoxDetailShow: ({
        commit
    }, param) => {
        commit("toggleBoxDetailShow", param);
    },
    setBoxId: ({
        commit
    }, param) => {
        commit("setBoxId", param);
    },
    change_currentAttributeDrawed: ({
        commit
    }, param) => {
        commit("change_currentAttributeDrawed", param);
    },
    change_currentEditedBox: ({
        commit
    }, param) => {
        commit("change_currentEditedBox", param);
    },
    change_isAdd: ({
        commit
    }, param) => {
        commit("change_isAdd", param);
    },
    change_isEleAdd: ({//围栏
        commit
    }, param) => {
        commit("change_isEleAdd", param);
    },

}

export default {
state,
getters,
mutations,
actions
};
